module.exports = __webpack_public_path__ + "static/media/guide-scrap.43360626.jpg";